module.exports = __webpack_public_path__ + "static/media/Emotes-Active.e1f25694.png";